/**
 * GitOAuthCallback — página pública de retorno do OAuth Git (popup).
 *
 * O GitHub redireciona o POPUP para cá (GIT_OAUTH_REDIRECT_URI) com ?code&state.
 * Esta página apenas devolve code+state à janela que abriu o popup (opener) via
 * postMessage — same-origin — e se fecha. A troca do código por token acontece no
 * opener (que ainda tem o access token em memória) chamando /integrations/git/.../
 * exchange. Se aberta fora de um popup (sem opener), volta para Configurações.
 *
 * Segurança: postMessage com targetOrigin = origin atual (nunca '*'); o opener
 * valida event.origin e o campo source. Não faz troca de token aqui.
 */
import { C } from '@/theme/palette';
import { useEffect, useState } from 'react';

export default function GitOAuthCallback() {
  const [standalone, setStandalone] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const msg = {
      source: 'nava-git-oauth',
      code: p.get('code') || '',
      state: p.get('state') || '',
      error: p.get('error') || p.get('error_description') || '',
    };
    if (window.opener && window.opener !== window) {
      try { window.opener.postMessage(msg, window.location.origin); } catch { /* ignore */ }
      // Fecha o popup; se o navegador bloquear o close, o texto abaixo orienta.
      window.close();
      setStandalone(true);
    } else {
      // Aberta diretamente (sem popup): não há como devolver — volta pra Settings.
      window.location.replace('/settings');
    }
  }, []);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: C.black, color: C.neutral, textAlign: 'center', padding: 24,
      fontFamily: '-apple-system,Segoe UI,Roboto,sans-serif', fontSize: 14, lineHeight: 1.6,
    }}>
      <div>
        Conectando sua conta do GitHub…
        {standalone && <div style={{ color: C.neutralDim, marginTop: 8 }}>Pode fechar esta janela.</div>}
      </div>
    </div>
  );
}
